import React from 'react';
import Component from '@vfuk/core-pill';
const Pill = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Pill;
